// extracted by mini-css-extract-plugin
export default {"drawerview":"bd680cd5eecb0027cc4c","container":"d135f54497c5d1ee2f76","entry":"ea34134270d454ab7794","slideRight":"db247f284faf3411fd78"};